<template>
    <div class="menu-category-select-wrap">
        <div class="menu-category-select">
            <ul class="menu-category-ul"
                ref="scrollBarRef">
                <li class="menu-category-button"
                    :class="{ 'selected': category.id == selectedCategory }"
                    v-for="category in categories"
                    :key="category.id"
                    @click="scrollMenu(category.id)">
                    {{ category.name }}
                </li>
            </ul>
            <div class="menu-category-open-all"
                 @click="showAll = true">
                <IconArrowDown />
            </div>
        </div>
        <MenuCategoryAll v-show="showAll"
                         @close="showAll = false"
                         :categories="categories"
                         :selected-category="selectedCategory"
                         @scrollMenu="scrollMenu"
                         :isShown="showAll" />
    </div>
</template>

<script>
import IconArrowDown from '@/components/icons/IconArrowDown.vue';
import MenuCategoryAll from './MenuCategoryAll.vue';

export default {
    name: "MenuCategorySelect",
    components: {
        IconArrowDown,
        MenuCategoryAll,
    },
    props: {
        categories: { type: Array, required: true },
        selectedCategory: { type: [String, Number], required: true },
    },
    data() {
        return {
            showAll: false,
        };
    },
    watch: {
        selectedCategory(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.scrollSelect();
                });
            }

        }
    },
    methods: {
        scrollSelect() {
            const categoryElement = this.$refs.scrollBarRef.getElementsByClassName('selected')[0];
            const categoryOffsetLeft = categoryElement.offsetLeft;
            const categoryWidth = categoryElement.offsetWidth;

            const centerPosition = categoryOffsetLeft - (this.$refs.scrollBarRef.clientWidth / 2) + (categoryWidth / 2);

            this.$refs.scrollBarRef.scrollTo({
                left: centerPosition,
                behavior: 'smooth',
            });
        },
        scrollMenu(id) {
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        },
    }
};
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.menu-category-select-wrap {
    position: sticky;
    top: 0;

    z-index: 1000;
    user-select: none;
}

.menu-category-select {
    display: flex;
    padding: 10px 0;

    border-bottom: 1px solid #EDEDED;

    background-color: white;
}

.menu-category-ul {
    display: flex;
    gap: 8px;

    padding-left: 16px;

    overflow-x: auto;
    scrollbar-width: none;

    .menu-category-button {
        flex-shrink: 0;

        padding: 10px 16px;

        font-weight: 510;
        font-size: 16px;
        line-height: 100%;
        text-transform: capitalize;

        border: 1px solid #EDEDED;
        border-radius: 8px;

        color: black;
        background-color: $color_white_titan;
    }

    .selected {
        color: white;
        background-color: $color_blue_cornflower;
    }
}

.menu-category-open-all {
    display: flex;
    align-items: center;

    padding: 0 12px;
}
</style>